import PrintIcon from '@mui/icons-material/Print';
import { Button } from 'react-admin';
import { useReactToPrint } from 'react-to-print';

const PrintSummaryButton = ({ reportSummaryRef, onClick }) => {
  const handlePrint = useReactToPrint({
    contentRef: reportSummaryRef,
    onBeforePrint: onClick,
  });

  return (
    <Button
      variant="outlined"
      sx={{ height: 32, marginBottom: '3px' }}
      label="Imprimir Totais"
      startIcon={<PrintIcon />}
      onClick={handlePrint}
    />
  );
};

export default PrintSummaryButton;